export const formatTimeBlock = (value, append = '0', count = 2) => value.toString().padStart(count, append);

export const formatGameTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    const milliseconds = Math.floor((time % 1) * 100);

    const timeFormatted = `${formatTimeBlock(minutes)}:${formatTimeBlock(seconds)}:${formatTimeBlock(milliseconds)}`;

    return timeFormatted;
};
